import { render, staticRenderFns } from "./CFormItem.vue?vue&type=template&id=645dc4fe"
import script from "./CFormItem.vue?vue&type=script&lang=js"
export * from "./CFormItem.vue?vue&type=script&lang=js"
import style0 from "./CFormItem.vue?vue&type=style&index=0&id=645dc4fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports